import styled, {css, keyframes} from 'styled-components'
import DialogStyle from '@material-ui/core/Dialog'
import DialogTitleStyle from '@material-ui/core/DialogTitle'
import DialogContentStyle from '@material-ui/core/DialogContent'
const show = keyframes`
    from {opacity: 0;}
    to {opacity: 1}
`

export const Header = styled(DialogTitleStyle)`
    && {
        padding: 24px 24px 6px;
        > h2 {
            display: flex;
            font-weight: bold;
            width: 100%;
            justify-content: space-between;
            align-items: center;
        }
    }
`

export const DialogBox = styled(DialogStyle)`
    && {
        ${({error}) => error && css`
            ${Header} {
                h2 {
                    color: #CC3537;
                }
            }
        `};
        height: calc(100% - 64px);
        margin-top: 64px;
        .dialog {
            max-width: unset;
        }
    }
`

export const Close = styled.span`
    color: ${({theme}) => theme.container.secondary.title};
    float: right;
    font-size: 28px;
    font-weight: bold;

    :hover, :focus {
        color: black;
        text-decoration: none;
        cursor: pointer;
    }
`



export const Content = styled(DialogContentStyle)`
    && {
        padding: 6px 24px 24px;
    }
`